var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_160723",
    "data-name": "Group 160723",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 272,
    height: 202.699,
    viewBox: "0 0 272 202.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140165",
    "data-name": "Rectangle 140165",
    width: 272,
    height: 202.699,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140160",
    "data-name": "Rectangle 140160",
    width: 151.044,
    height: 116.945,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140161",
    "data-name": "Rectangle 140161",
    width: 12.776,
    height: 33.07,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140162",
    "data-name": "Rectangle 140162",
    width: 30.937,
    height: 31.394,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160722",
    "data-name": "Group 160722",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140153",
    "data-name": "Rectangle 140153",
    width: 272,
    height: 0.136,
    transform: "translate(0 178.131)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160721",
    "data-name": "Group 160721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160720",
    "data-name": "Group 160720",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83195",
    "data-name": "Path 83195",
    d: "M146.358,153.869H41.312a3.109,3.109,0,0,1-3.105-3.105V3.105A3.109,3.109,0,0,1,41.312,0H146.358a3.109,3.109,0,0,1,3.1,3.105V150.764a3.108,3.108,0,0,1-3.1,3.105M41.312.136a2.972,2.972,0,0,0-2.969,2.969V150.764a2.972,2.972,0,0,0,2.969,2.969H146.358a2.972,2.972,0,0,0,2.969-2.969V3.105A2.972,2.972,0,0,0,146.358.136Z",
    transform: "translate(-17.422)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83196",
    "data-name": "Path 83196",
    d: "M362.655,153.869H257.61a3.108,3.108,0,0,1-3.1-3.105V3.105A3.108,3.108,0,0,1,257.61,0H362.655a3.109,3.109,0,0,1,3.105,3.105V150.764a3.109,3.109,0,0,1-3.105,3.105M257.61.136a2.972,2.972,0,0,0-2.969,2.969V150.764a2.972,2.972,0,0,0,2.969,2.969H362.655a2.973,2.973,0,0,0,2.969-2.969V3.105A2.973,2.973,0,0,0,362.655.136Z",
    transform: "translate(-116.054)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140154",
    "data-name": "Rectangle 140154",
    width: 14.142,
    height: 0.136,
    transform: "translate(27.896 183.312)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140155",
    "data-name": "Rectangle 140155",
    width: 24.495,
    height: 0.136,
    transform: "translate(78.963 181.835)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140156",
    "data-name": "Rectangle 140156",
    width: 33.071,
    height: 0.136,
    transform: "translate(42.583 188.363)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140157",
    "data-name": "Rectangle 140157",
    width: 10.463,
    height: 0.136,
    transform: "translate(233.641 187.449)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140158",
    "data-name": "Rectangle 140158",
    width: 30.079,
    height: 0.136,
    transform: "translate(198.718 187.449)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140159",
    "data-name": "Rectangle 140159",
    width: 40.51,
    height: 0.136,
    transform: "translate(139.833 185.152)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83197",
    "data-name": "Path 83197",
    d: "M185.062,160.488l-6.884,90.826h66.357l6.884-90.826Zm41.728,64.2A14.719,14.719,0,0,1,212.358,238.1a12.261,12.261,0,0,1-12.4-13.415l2.42-31.933a14.724,14.724,0,0,1,14.432-13.42,12.265,12.265,0,0,1,12.4,13.42Z",
    transform: "translate(-81.249 -73.183)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83198",
    "data-name": "Path 83198",
    d: "M257.766,322.451H161l.558-5.959h96.761Z",
    transform: "translate(-73.418 -144.32)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83199",
    "data-name": "Path 83199",
    d: "M406.415,263.451h8.568a.841.841,0,0,0,.845-.89l-.03-.608a.949.949,0,0,0-.935-.89H406.3a.841.841,0,0,0-.845.89l.03.608a.949.949,0,0,0,.935.89",
    transform: "translate(-184.885 -119.045)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83200",
    "data-name": "Path 83200",
    d: "M380.076,263.451h8.568a.841.841,0,0,0,.845-.89l-.03-.608a.949.949,0,0,0-.935-.89h-8.568a.841.841,0,0,0-.845.89l.03.608a.949.949,0,0,0,.935.89",
    transform: "translate(-172.874 -119.045)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83201",
    "data-name": "Path 83201",
    d: "M258.862,156.522H58.874a4.439,4.439,0,0,1-4.385-4.176L48.469,32.22a3.933,3.933,0,0,1,3.966-4.176H252.423a4.44,4.44,0,0,1,4.386,4.176l6.02,120.125a3.933,3.933,0,0,1-3.967,4.176",
    transform: "translate(-22.099 -12.788)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83202",
    "data-name": "Path 83202",
    d: "M263.366,156.522H63.378a4.439,4.439,0,0,1-4.385-4.176L52.973,32.22a3.934,3.934,0,0,1,3.967-4.176H256.927a4.44,4.44,0,0,1,4.386,4.176l6.02,120.125a3.933,3.933,0,0,1-3.967,4.176",
    transform: "translate(-24.153 -12.788)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83203",
    "data-name": "Path 83203",
    d: "M69.561,152.972l-5.6-111.71a2.465,2.465,0,0,1,2.486-2.617H258.022a2.782,2.782,0,0,1,2.748,2.617l5.6,111.71a2.465,2.465,0,0,1-2.486,2.617H72.309a2.782,2.782,0,0,1-2.748-2.617",
    transform: "translate(-29.165 -17.622)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83204",
    "data-name": "Path 83204",
    d: "M81.779,47.209a2.181,2.181,0,0,1-2.2,2.315,2.461,2.461,0,0,1-2.431-2.315,2.181,2.181,0,0,1,2.2-2.315,2.461,2.461,0,0,1,2.431,2.315",
    transform: "translate(-35.178 -20.472)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83205",
    "data-name": "Path 83205",
    d: "M101.051,47.209a2.181,2.181,0,0,1-2.2,2.315,2.461,2.461,0,0,1-2.431-2.315,2.181,2.181,0,0,1,2.2-2.315,2.461,2.461,0,0,1,2.431,2.315",
    transform: "translate(-43.966 -20.472)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83206",
    "data-name": "Path 83206",
    d: "M120.323,47.209a2.181,2.181,0,0,1-2.2,2.315,2.461,2.461,0,0,1-2.431-2.315,2.181,2.181,0,0,1,2.2-2.315,2.461,2.461,0,0,1,2.431,2.315",
    transform: "translate(-52.754 -20.472)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160713",
    "data-name": "Group 160713",
    transform: "translate(60.316 21.022)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160712",
    "data-name": "Group 160712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160711",
    "data-name": "Group 160711",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83207",
    "data-name": "Path 83207",
    d: "M110.875,155.589h27.608L163.725,38.644H136.117Z",
    transform: "translate(-110.875 -38.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83208",
    "data-name": "Path 83208",
    d: "M329.284,155.589h6.988L361.513,38.644h-6.988Z",
    transform: "translate(-210.469 -38.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83209",
    "data-name": "Path 83209",
    d: "M172.908,155.589h39.169L237.319,38.644H198.15Z",
    transform: "translate(-139.162 -38.644)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_83210",
    "data-name": "Path 83210",
    d: "M267.062,356.123c0,3.4-47.223,6.16-105.476,6.16s-105.476-2.758-105.476-6.16,47.223-6.16,105.476-6.16,105.476,2.758,105.476,6.16",
    transform: "translate(-25.587 -159.583)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83211",
    "data-name": "Path 83211",
    d: "M339.139,183.24c-.066,0-.132,0-.2-.008-14.488-1.185-24.463-13.571-24.88-14.1a2.43,2.43,0,0,1,3.806-3.021c.117.145,8.652,10.667,20.469,12.17,3.833-3.8,7.061-13.864,6.708-16.906,0-.028-.005-.057-.008-.085-.079-.979-.262-4.332.7-6.334a2.43,2.43,0,0,1,4.38,2.107,11.274,11.274,0,0,0-.24,3.8c.541,5.006-3.8,17.638-9.25,21.862a2.43,2.43,0,0,1-1.488.509",
    transform: "translate(-142.972 -70.033)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83212",
    "data-name": "Path 83212",
    d: "M126.16,143.651A35.808,35.808,0,0,1,99.74,131.532a2.432,2.432,0,0,1-.139-3.07c3.926-5.281,10.858-17.757,11.939-21.822a5.918,5.918,0,0,0-2.254-2.354,2.43,2.43,0,0,1-1.385-1.961l-.394-3.984a2.43,2.43,0,1,1,4.837-.478l.274,2.77a12.088,12.088,0,0,1,3.7,4.7,2.429,2.429,0,0,1,.177,1.229c-.5,4.318-7.5,16.81-11.81,23.126a30.411,30.411,0,0,0,22.608,9.064,2.43,2.43,0,0,1,.443,4.84c-.113.01-.671.057-1.578.057",
    transform: "translate(-45.2 -43.626)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83213",
    "data-name": "Path 83213",
    d: "M284.278,322.751h-6.512a2.43,2.43,0,0,1-2.341-3.082,91.214,91.214,0,0,0,3.163-18.88c-2.3-10.852-4.476-20.787-4.5-20.888a2.43,2.43,0,0,1,4.747-1.038c.022.1,2.243,10.261,4.578,21.262a2.43,2.43,0,0,1,.046.7,100.166,100.166,0,0,1-2.544,17.07h3.361a2.43,2.43,0,1,1,0,4.86",
    transform: "translate(-124.959 -126.29)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83214",
    "data-name": "Path 83214",
    d: "M195.2,322.75h-3.677a2.431,2.431,0,0,1-2.407-2.766c.623-4.462,3.829-12.585,7.233-20.75,1.214-10.771,2.207-20.019,2.217-20.112a2.43,2.43,0,0,1,4.832.518c-.01.094-1.025,9.551-2.259,20.482a2.421,2.421,0,0,1-.172.664,174.356,174.356,0,0,0-6.42,17.1h.653a2.43,2.43,0,1,1,0,4.86",
    transform: "translate(-86.228 -126.289)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83215",
    "data-name": "Path 83215",
    d: "M179.611,56.028,151.287,84.351c-1.425,31.4-1.308,64.372,0,98.566h93.656c-1.854-44.122-2.03-86.592,0-126.89Z",
    transform: "translate(-68.519 -25.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83216",
    "data-name": "Path 83216",
    d: "M244.543,183H150.886a.486.486,0,0,1-.486-.467c-1.358-35.5-1.358-68.678,0-98.606a.486.486,0,0,1,.141-.322l28.324-28.323a.484.484,0,0,1,.343-.143h65.333a.485.485,0,0,1,.485.51c-1.955,38.811-1.955,80.3,0,126.844a.484.484,0,0,1-.485.506m-93.189-.971h92.683c-1.927-46.163-1.928-87.363,0-125.918H179.411L151.363,84.155c-1.343,29.72-1.346,62.644-.009,97.869",
    transform: "translate(-68.118 -25.142)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83217",
    "data-name": "Path 83217",
    d: "M284.573,263.9H274.358a.363.363,0,0,1,0-.727h10.214a.363.363,0,1,1,0,.727",
    transform: "translate(-124.942 -120.007)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83218",
    "data-name": "Path 83218",
    d: "M228.337,263.9H182.713a.363.363,0,0,1,0-.727h45.624a.363.363,0,1,1,0,.727",
    transform: "translate(-83.152 -120.007)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83219",
    "data-name": "Path 83219",
    d: "M209.555,187.247c-.107-2.368-1.454-4.243-3.009-4.187s-2.727,2.021-2.62,4.389,1.454,4.243,3.008,4.187,2.728-2.021,2.62-4.389",
    transform: "translate(-92.987 -83.475)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83220",
    "data-name": "Path 83220",
    d: "M269.926,185.887c-.107-2.368-1.454-4.243-3.009-4.187s-2.727,2.021-2.62,4.389,1.454,4.243,3.008,4.187,2.728-2.021,2.62-4.39",
    transform: "translate(-120.516 -82.855)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83221",
    "data-name": "Path 83221",
    d: "M226.647,207.565a19.848,19.848,0,0,1,15.573.709.692.692,0,0,1,.269.944.7.7,0,0,1-.954.265,19.122,19.122,0,0,0-17.085.552.707.707,0,0,1-.946-.3.689.689,0,0,1,.3-.936,23.258,23.258,0,0,1,2.847-1.24",
    transform: "translate(-101.881 -94.087)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83222",
    "data-name": "Path 83222",
    d: "M196.494,149.912a1.4,1.4,0,0,1,1.183,2.1,13.756,13.756,0,0,1-10.63,6.945,1.408,1.408,0,0,1-1.463-1.335,1.38,1.38,0,0,1,1.323-1.444,10.982,10.982,0,0,0,8.356-5.591,1.387,1.387,0,0,1,1.231-.678",
    transform: "translate(-84.625 -68.36)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83223",
    "data-name": "Path 83223",
    d: "M265.113,148.422a1.412,1.412,0,0,1,1.268.388,11.2,11.2,0,0,0,9.531,3.439,1.414,1.414,0,0,1,1.649,1.094,1.375,1.375,0,0,1-1.079,1.631,14.041,14.041,0,0,1-12.082-4.212,1.382,1.382,0,0,1,.712-2.34",
    transform: "translate(-120.38 -67.669)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160716",
    "data-name": "Group 160716",
    transform: "translate(162.425 48.864)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160715",
    "data-name": "Group 160715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160714",
    "data-name": "Group 160714",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83224",
    "data-name": "Path 83224",
    d: "M311.165,122.509l-3.972.373a2.839,2.839,0,0,1-3.037-2.209l-5.511-24.687a2.839,2.839,0,0,1,2.05-3.365l10.657-2.8Z",
    transform: "translate(-298.576 -89.824)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160719",
    "data-name": "Group 160719",
    transform: "translate(82.768 30.479)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160718",
    "data-name": "Group 160718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160717",
    "data-name": "Group 160717",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83225",
    "data-name": "Path 83225",
    d: "M183.084,86.879c-2.769-7.561-5.537-19.653-2.613-30.852L152.147,84.351c8,2.678,20.766,3.843,30.937,2.528",
    transform: "translate(-152.147 -56.028)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_83226",
    "data-name": "Path 83226",
    d: "M180.47,84.351c-3.105-9.171-1.839-21.64,0-28.323L152.147,84.351c8.575,1.561,18.153,1.315,28.323,0",
    transform: "translate(-69.379 -25.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83227",
    "data-name": "Path 83227",
    d: "M164.692,85.511a72.752,72.752,0,0,1-13.039-1.089.486.486,0,0,1-.257-.821L179.72,55.279a.485.485,0,0,1,.812.472c-1.712,6.223-3.127,18.825-.009,28.039a.485.485,0,0,1-.4.637,120.758,120.758,0,0,1-15.434,1.085m-11.947-1.884c7.525,1.247,16.268,1.217,26.675-.089-2.56-8.124-1.982-18.878-.258-26.328Z",
    transform: "translate(-68.972 -25.142)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83228",
    "data-name": "Path 83228",
    d: "M374.062,150.935a.812.812,0,0,1-.785-.607L363.3,112.314a.812.812,0,0,1,1.571-.412l9.975,38.014a.811.811,0,0,1-.579.992.8.8,0,0,1-.207.027",
    transform: "translate(-165.653 -50.75)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140163",
    "data-name": "Rectangle 140163",
    width: 0.544,
    height: 2.998,
    transform: "translate(226.121 44.645) rotate(-14.705)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83229",
    "data-name": "Path 83229",
    d: "M403.334,66.357l-2.1-7.985a4.207,4.207,0,0,0-5.142-3L390.618,56.8l-.138-.526,5.478-1.438a4.751,4.751,0,0,1,5.807,3.392l2.1,7.985Z",
    transform: "translate(-178.059 -24.936)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83230",
    "data-name": "Path 83230",
    d: "M366.668,98.251,314.8,111.86a2.852,2.852,0,0,1-3.482-2.035L302.279,75.37a2.852,2.852,0,0,1,2.035-3.482l51.865-13.609a2.85,2.85,0,0,1,3.481,2.034L368.7,94.769a2.851,2.851,0,0,1-2.034,3.482",
    transform: "translate(-137.796 -26.532)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83231",
    "data-name": "Path 83231",
    d: "M326.87,109.81l-3.224.866-1.641-6.113.789-.212,1.454,5.414,2.434-.654Z",
    transform: "translate(-146.834 -47.584)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83232",
    "data-name": "Path 83232",
    d: "M326.87,109.81l-3.224.866-1.641-6.113.789-.212,1.454,5.414,2.434-.654Z",
    transform: "translate(-146.834 -47.584)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83233",
    "data-name": "Path 83233",
    d: "M329.76,105.312a3.473,3.473,0,0,1,.169-2.571,2.9,2.9,0,0,1,1.935-1.459,2.735,2.735,0,0,1,2.282.305,3.307,3.307,0,0,1,1.376,2.021,3.481,3.481,0,0,1-.164,2.574,2.843,2.843,0,0,1-1.9,1.444,2.79,2.79,0,0,1-2.318-.3,3.277,3.277,0,0,1-1.383-2.018m.812-.286a2.751,2.751,0,0,0,1.043,1.625,1.909,1.909,0,0,0,1.658.273,2,2,0,0,0,1.365-1.054,2.738,2.738,0,0,0,.077-1.943,2.838,2.838,0,0,0-1.037-1.68,1.929,1.929,0,0,0-1.67-.242,1.967,1.967,0,0,0-1.333,1.086,2.738,2.738,0,0,0-.1,1.936",
    transform: "translate(-150.296 -46.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83234",
    "data-name": "Path 83234",
    d: "M329.76,105.312a3.473,3.473,0,0,1,.169-2.571,2.9,2.9,0,0,1,1.935-1.459,2.735,2.735,0,0,1,2.282.305,3.307,3.307,0,0,1,1.376,2.021,3.481,3.481,0,0,1-.164,2.574,2.843,2.843,0,0,1-1.9,1.444,2.79,2.79,0,0,1-2.318-.3A3.277,3.277,0,0,1,329.76,105.312Zm.812-.286a2.751,2.751,0,0,0,1.043,1.625,1.909,1.909,0,0,0,1.658.273,2,2,0,0,0,1.365-1.054,2.738,2.738,0,0,0,.077-1.943,2.838,2.838,0,0,0-1.037-1.68,1.929,1.929,0,0,0-1.67-.242,1.967,1.967,0,0,0-1.333,1.086A2.738,2.738,0,0,0,330.571,105.026Z",
    transform: "translate(-150.296 -46.131)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83235",
    "data-name": "Path 83235",
    d: "M347.593,103.181a4.256,4.256,0,0,1-1.928,1.076,2.936,2.936,0,0,1-2.362-.265,3.192,3.192,0,0,1-1.412-2.021,3.3,3.3,0,0,1,.271-2.569,3.191,3.191,0,0,1,2.052-1.528,4.14,4.14,0,0,1,1.762-.134l.228.852a3.338,3.338,0,0,0-1.872.008,2.246,2.246,0,0,0-1.462,1.124,3,3,0,0,0,.912,3.6,2.17,2.17,0,0,0,1.782.207,2.533,2.533,0,0,0,1.116-.588l-.444-1.653-1.326.356-.188-.7,2.119-.568Z",
    transform: "translate(-155.838 -44.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83236",
    "data-name": "Path 83236",
    d: "M347.593,103.181a4.256,4.256,0,0,1-1.928,1.076,2.936,2.936,0,0,1-2.362-.265,3.192,3.192,0,0,1-1.412-2.021,3.3,3.3,0,0,1,.271-2.569,3.191,3.191,0,0,1,2.052-1.528,4.14,4.14,0,0,1,1.762-.134l.228.852a3.338,3.338,0,0,0-1.872.008,2.246,2.246,0,0,0-1.462,1.124,3,3,0,0,0,.912,3.6,2.17,2.17,0,0,0,1.782.207,2.533,2.533,0,0,0,1.116-.588l-.444-1.653-1.326.356-.188-.7,2.119-.568Z",
    transform: "translate(-155.838 -44.549)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83237",
    "data-name": "Path 83237",
    d: "M353.346,101.016a2.266,2.266,0,0,0,.858.2,2.883,2.883,0,0,0,.934-.082q1.287-.345,1.041-1.261a.837.837,0,0,0-.262-.424,1.364,1.364,0,0,0-.476-.261,10.445,10.445,0,0,0-1.034-.243,3.613,3.613,0,0,1-1.439-.524,1.519,1.519,0,0,1-.533-.82,1.467,1.467,0,0,1,.287-1.372,2.64,2.64,0,0,1,1.423-.86,3.155,3.155,0,0,1,1.4-.138l.231.86a2.486,2.486,0,0,0-1.5-.007,1.676,1.676,0,0,0-.851.48.767.767,0,0,0-.178.747.822.822,0,0,0,.406.538,5.083,5.083,0,0,0,1.233.351,3.878,3.878,0,0,1,1.489.523,1.517,1.517,0,0,1,.619.87,1.492,1.492,0,0,1-.252,1.392,2.782,2.782,0,0,1-1.506.866,4.442,4.442,0,0,1-.874.127,2.126,2.126,0,0,1-.771-.062Z",
    transform: "translate(-160.682 -43.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83238",
    "data-name": "Path 83238",
    d: "M353.346,101.016a2.266,2.266,0,0,0,.858.2,2.883,2.883,0,0,0,.934-.082q1.287-.345,1.041-1.261a.837.837,0,0,0-.262-.424,1.364,1.364,0,0,0-.476-.261,10.445,10.445,0,0,0-1.034-.243,3.613,3.613,0,0,1-1.439-.524,1.519,1.519,0,0,1-.533-.82,1.467,1.467,0,0,1,.287-1.372,2.64,2.64,0,0,1,1.423-.86,3.155,3.155,0,0,1,1.4-.138l.231.86a2.486,2.486,0,0,0-1.5-.007,1.676,1.676,0,0,0-.851.48.767.767,0,0,0-.178.747.822.822,0,0,0,.406.538,5.083,5.083,0,0,0,1.233.351,3.878,3.878,0,0,1,1.489.523,1.517,1.517,0,0,1,.619.87,1.492,1.492,0,0,1-.252,1.392,2.782,2.782,0,0,1-1.506.866,4.442,4.442,0,0,1-.874.127,2.126,2.126,0,0,1-.771-.062Z",
    transform: "translate(-160.682 -43.411)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83239",
    "data-name": "Path 83239",
    d: "M371.836,96.794l-.935.251-4.351-3.93a2.442,2.442,0,0,1-.316-.342l-.023.006a7.426,7.426,0,0,1,.261.848l1.154,4.3-.781.209L365.2,92.021l.991-.266,4.245,3.869a4.41,4.41,0,0,1,.366.355l.016,0a7.116,7.116,0,0,1-.279-.882l-1.128-4.2.781-.209Z",
    transform: "translate(-166.533 -41.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83240",
    "data-name": "Path 83240",
    d: "M371.836,96.794l-.935.251-4.351-3.93a2.442,2.442,0,0,1-.316-.342l-.023.006a7.426,7.426,0,0,1,.261.848l1.154,4.3-.781.209L365.2,92.021l.991-.266,4.245,3.869a4.41,4.41,0,0,1,.366.355l.016,0a7.116,7.116,0,0,1-.279-.882l-1.128-4.2.781-.209Z",
    transform: "translate(-166.533 -41.351)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83241",
    "data-name": "Path 83241",
    d: "M377.963,92.372a3.473,3.473,0,0,1,.169-2.571,2.9,2.9,0,0,1,1.935-1.459,2.734,2.734,0,0,1,2.282.305,3.3,3.3,0,0,1,1.376,2.022,3.482,3.482,0,0,1-.163,2.574,2.843,2.843,0,0,1-1.9,1.444,2.791,2.791,0,0,1-2.317-.3,3.282,3.282,0,0,1-1.384-2.019m.812-.286a2.753,2.753,0,0,0,1.043,1.625,1.909,1.909,0,0,0,1.658.273,2,2,0,0,0,1.365-1.054,2.737,2.737,0,0,0,.077-1.943,2.838,2.838,0,0,0-1.037-1.68,1.929,1.929,0,0,0-1.67-.242,1.968,1.968,0,0,0-1.333,1.086,2.741,2.741,0,0,0-.1,1.936",
    transform: "translate(-172.276 -40.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83242",
    "data-name": "Path 83242",
    d: "M377.963,92.372a3.473,3.473,0,0,1,.169-2.571,2.9,2.9,0,0,1,1.935-1.459,2.734,2.734,0,0,1,2.282.305,3.3,3.3,0,0,1,1.376,2.022,3.482,3.482,0,0,1-.163,2.574,2.843,2.843,0,0,1-1.9,1.444,2.791,2.791,0,0,1-2.317-.3A3.282,3.282,0,0,1,377.963,92.372Zm.812-.286a2.753,2.753,0,0,0,1.043,1.625,1.909,1.909,0,0,0,1.658.273,2,2,0,0,0,1.365-1.054,2.737,2.737,0,0,0,.077-1.943,2.838,2.838,0,0,0-1.037-1.68,1.929,1.929,0,0,0-1.67-.242,1.968,1.968,0,0,0-1.333,1.086A2.741,2.741,0,0,0,378.774,92.086Z",
    transform: "translate(-172.276 -40.23)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83243",
    "data-name": "Path 83243",
    d: "M392.033,85.724l-1.764.474,1.452,5.41-.793.213-1.452-5.411-1.756.472-.188-.7,4.313-1.158Z",
    transform: "translate(-176.715 -38.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83244",
    "data-name": "Path 83244",
    d: "M392.033,85.724l-1.764.474,1.452,5.41-.793.213-1.452-5.411-1.756.472-.188-.7,4.313-1.158Z",
    transform: "translate(-176.715 -38.77)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83245",
    "data-name": "Path 83245",
    d: "M340.477,118.938l-2.36.634.549,2.044,2.186-.588.187.695-2.186.587.718,2.672-.789.212-1.641-6.113,3.149-.845Z",
    transform: "translate(-153.736 -53.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83246",
    "data-name": "Path 83246",
    d: "M340.477,118.938l-2.36.634.549,2.044,2.186-.588.187.695-2.186.587.718,2.672-.789.212-1.641-6.113,3.149-.845Z",
    transform: "translate(-153.736 -53.915)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83247",
    "data-name": "Path 83247",
    d: "M345.714,120.142a3.473,3.473,0,0,1,.169-2.571,2.9,2.9,0,0,1,1.935-1.459,2.735,2.735,0,0,1,2.282.305,3.3,3.3,0,0,1,1.376,2.021,3.479,3.479,0,0,1-.164,2.574,2.844,2.844,0,0,1-1.9,1.444,2.794,2.794,0,0,1-2.318-.3,3.28,3.28,0,0,1-1.383-2.019m.812-.286a2.751,2.751,0,0,0,1.043,1.625,1.909,1.909,0,0,0,1.658.273,2,2,0,0,0,1.365-1.054,2.737,2.737,0,0,0,.077-1.943,2.838,2.838,0,0,0-1.037-1.68,1.929,1.929,0,0,0-1.67-.242,1.967,1.967,0,0,0-1.333,1.086,2.738,2.738,0,0,0-.1,1.936",
    transform: "translate(-157.571 -52.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83248",
    "data-name": "Path 83248",
    d: "M345.714,120.142a3.473,3.473,0,0,1,.169-2.571,2.9,2.9,0,0,1,1.935-1.459,2.735,2.735,0,0,1,2.282.305,3.3,3.3,0,0,1,1.376,2.021,3.479,3.479,0,0,1-.164,2.574,2.844,2.844,0,0,1-1.9,1.444,2.794,2.794,0,0,1-2.318-.3A3.28,3.28,0,0,1,345.714,120.142Zm.812-.286a2.751,2.751,0,0,0,1.043,1.625,1.909,1.909,0,0,0,1.658.273,2,2,0,0,0,1.365-1.054,2.737,2.737,0,0,0,.077-1.943,2.838,2.838,0,0,0-1.037-1.68,1.929,1.929,0,0,0-1.67-.242,1.967,1.967,0,0,0-1.333,1.086A2.738,2.738,0,0,0,346.525,119.856Z",
    transform: "translate(-157.571 -52.893)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83249",
    "data-name": "Path 83249",
    d: "M362.579,115.808q.7,2.593-1.656,3.224-2.253.6-2.925-1.9l-1-3.713.789-.212.987,3.678q.492,1.835,2.031,1.422,1.488-.4,1.011-2.175l-1-3.737.789-.212Z",
    transform: "translate(-162.792 -51.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83250",
    "data-name": "Path 83250",
    d: "M362.579,115.808q.7,2.593-1.656,3.224-2.253.6-2.925-1.9l-1-3.713.789-.212.987,3.678q.492,1.835,2.031,1.422,1.488-.4,1.011-2.175l-1-3.737.789-.212Z",
    transform: "translate(-162.792 -51.157)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83251",
    "data-name": "Path 83251",
    d: "M374.863,115.093l-.935.251-4.351-3.93a2.442,2.442,0,0,1-.316-.342l-.023.006a7.413,7.413,0,0,1,.261.848l1.154,4.3-.781.21-1.641-6.113.991-.266,4.245,3.869a4.53,4.53,0,0,1,.366.354l.016,0a7.061,7.061,0,0,1-.279-.881l-1.128-4.2.782-.21Z",
    transform: "translate(-167.913 -49.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83252",
    "data-name": "Path 83252",
    d: "M374.863,115.093l-.935.251-4.351-3.93a2.442,2.442,0,0,1-.316-.342l-.023.006a7.413,7.413,0,0,1,.261.848l1.154,4.3-.781.21-1.641-6.113.991-.266,4.245,3.869a4.53,4.53,0,0,1,.366.354l.016,0a7.061,7.061,0,0,1-.279-.881l-1.128-4.2.782-.21Z",
    transform: "translate(-167.913 -49.695)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83253",
    "data-name": "Path 83253",
    d: "M381.95,113.8l-1.641-6.112,1.744-.468a3.494,3.494,0,0,1,2.527.189,2.841,2.841,0,0,1,1.5,1.923,3.068,3.068,0,0,1-.31,2.525,3.466,3.466,0,0,1-2.144,1.493Zm-.663-5.622,1.265,4.712.888-.238a2.584,2.584,0,0,0,1.647-1.122,2.454,2.454,0,0,0,.176-1.955,2.221,2.221,0,0,0-1.133-1.541,2.707,2.707,0,0,0-1.918-.1Z",
    transform: "translate(-173.421 -48.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83254",
    "data-name": "Path 83254",
    d: "M381.95,113.8l-1.641-6.112,1.744-.468a3.494,3.494,0,0,1,2.527.189,2.841,2.841,0,0,1,1.5,1.923,3.068,3.068,0,0,1-.31,2.525,3.466,3.466,0,0,1-2.144,1.493Zm-.663-5.622,1.265,4.712.888-.238a2.584,2.584,0,0,0,1.647-1.122,2.454,2.454,0,0,0,.176-1.955,2.221,2.221,0,0,0-1.133-1.541,2.707,2.707,0,0,0-1.918-.1Z",
    transform: "translate(-173.421 -48.823)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationIcon);
export default __webpack_public_path__ + "static/media/Illustration-icon.702cb017c683fdf6cea9cbe0f429b193.svg";
export { ForwardRef as ReactComponent };